import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { COOKIE_NAME_TOKEN } from "../../constants/cookies";
import { CircularProgress, Container } from "@material-ui/core";
import styled from "styled-components";

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
`;

const LoadingText = styled.p`
  margin-top: 16px;
  color: #666666;
  font-size: 16px;
`;

export const RedirectConnectToLesson: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const ltik = searchParams.get("ltik");

    if (ltik) {
      // Сохраняем ltik в cookies как токен
      Cookies.set(COOKIE_NAME_TOKEN, ltik, { expires: 1 });
      
      // Редиректим на lesson-list
      history.replace("/lesson-list");
    } else {
      // Если нет ltik, редиректим на логин
      history.replace("/login");
    }
  }, [history, location.search]);

  return (
    <Container maxWidth="lg">
      <LoadingContainer>
        <CircularProgress color="primary" size={60} />
        <LoadingText>Подключение к системе уроков...</LoadingText>
      </LoadingContainer>
    </Container>
  );
};